
export enum DashboardStoreUpdateType {
    SECURITY,
    SYNC,
    UPDATE_WIDGET,
    REMOVE_WIDGET,
    ADD_DASHBOARD,
    REMOVE_DASHBOARD
}
